export default {
    googleClientId: "1025537527851-gg2rrp3dm013vo6u5t1ck179sumtdspv.apps.googleusercontent.com",
    facebookAppId: "262131947223648",
    facebookApiVersion: "2.11",
    facebookPermissions: "public_profile,email"
};


// WEBPACK FOOTER //
// ../conf/prod.js